
import { BookingFormData } from "../ParcelBookingForm";
import { useGoogleMapsKey } from "@/hooks/useGoogleMapsKey";
import { AddressSection } from "../address-form/AddressSection";
import { useAddressValidation } from "@/hooks/address/useAddressValidation";
import { useAddressHandlers } from "@/hooks/address/useAddressHandlers";
import { useAddressPlaceHandlers } from "@/hooks/address/useAddressPlaceHandlers";

interface AddressStepProps {
  formData: BookingFormData;
  setFormData: React.Dispatch<React.SetStateAction<BookingFormData>>;
  onValidationChange?: (isValid: boolean) => void;
}

const AddressStep = ({ formData, setFormData, onValidationChange }: AddressStepProps) => {
  const { apiKey, error, isLoading } = useGoogleMapsKey();

  const { validateAddresses } = useAddressValidation({
    collectionAddress: formData.collectionAddress,
    deliveryAddress: formData.deliveryAddress,
    onValidationChange,
  });

  const { handleCollectionChange, handleDeliveryChange } = useAddressHandlers({
    formData,
    setFormData,
    validateAddresses,
  });

  const { handleCollectionSelect, handleDeliverySelect } = useAddressPlaceHandlers({
    formData,
    setFormData,
    validateAddresses,
  });

  if (isLoading) {
    return <div className="flex items-center justify-center p-4">Loading address search...</div>;
  }

  if (error) {
    return <div className="text-red-500 p-4">{error}</div>;
  }

  if (!apiKey) {
    return <div className="text-red-500 p-4">Unable to load address search. Please check your configuration.</div>;
  }

  return (
    <div className="space-y-6 sm:space-y-8">
      <AddressSection
        title="Collection Address"
        values={formData.collectionAddress}
        onChange={handleCollectionChange}
        onPlaceSelect={handleCollectionSelect}
        prefix="collection"
      />
      <AddressSection
        title="Delivery Address"
        values={formData.deliveryAddress}
        onChange={handleDeliveryChange}
        onPlaceSelect={handleDeliverySelect}
        prefix="delivery"
      />
    </div>
  );
};

export default AddressStep;
